import React from 'react';
import RangeSlider from './RangeSlider';
import { Container, Title } from './styles/PlanEventSliderBlock.styled';

export default function PlanEventSliderBlock({ dir, id }) {
  const title = dir === 'rtl' ? 'كم هو عدد الحضور المتوقع؟ ' : 'How many attendees are expected?';
  const isIphone =
    typeof window !== 'undefined' &&
    /^((?!chrome|android).)*iPhone/i.test(window.navigator.userAgent);
  const isSafari =
    typeof window !== 'undefined' &&
    /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
  return (
    <Container
      className={`planrange_wrapper ${isIphone ? 'iphone' : ''} ${isSafari ? 'safari' : ''}`}
      id={id}
      dir={dir}
    >
      <Title dir={dir}>{title}</Title>
      <RangeSlider
        defaultValue={550}
        max={1000}
        min={100}
        step={10}
        marks={[100, 325, 550, 775, 1000]}
        dir={dir}
      />
    </Container>
  );
}
